import { config } from '../config';
import { authHeader } from '../helpers';
import axiosInstance from '../axiosInstance';

export const ifaCodesService = {
  getIfaCodes
};

function getIfaCodes() {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance.get(`${config.ifaCodes}`, requestOptions).then((responce) => {
    return responce.data;
  });
}
